export default ({ facebook, twitter, linkedIn, instagram }) => {
	return {
		socialLinks: {
			facebook,
			twitter,
			linkedIn,
			instagram,
		},
	};
};
